// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Spinner */

.HIdCQAgqDJwvD0V9SNbS {
	--color-rgb: 94, 190, 214;
	display: flex;
    justify-content: center;
    align-items: center;
	width: 100%;
    height: 100%;
    max-width: 100px;
    max-height: 100px;
    aspect-ratio: 1/1;
	padding-left: calc(-0.5rem / 2);
	padding-right: calc(-0.5rem / 2);
	overflow: hidden;
}

.HIdCQAgqDJwvD0V9SNbS::before {
	content: "";
	display: inline-block;
	width: 100%;
	max-width: 90%;
    max-height: 90%;
	--border-width: clamp(0.2em, 10%, 0.5em);
	border-radius: 50%;
	aspect-ratio: 1/1;
	--mask: radial-gradient(
		farthest-side,
		transparent calc(100% - var(--border-width) - 0.5px),
		#000 calc(100% - var(--border-width) + 0.5px)
	);
	-webkit-mask: var(--mask);
	        mask: var(--mask);
	background: linear-gradient(to top, rgba(var(--color-rgb), 1), rgba(var(--color-rgb), 0.5)) 100% 0/50% 100% no-repeat,
			linear-gradient(rgba(var(--color-rgb), 0.5) 50%, transparent 95%) 0 0/50% 100% no-repeat;
	animation: ubGSyLN9r1iyyU2ysL8D .85s linear infinite;
}

.HIdCQAgqDJwvD0V9SNbS.ruv_DA3ta96laLErzD91 {
	--color-rgb: 255, 255, 255;
}

.HIdCQAgqDJwvD0V9SNbS.ugaDW5dB4BqWMOAundeZ {
	--color-rgb: 251, 163, 29;
}

.HIdCQAgqDJwvD0V9SNbS.T9zL9FLLrHf6kvbpGe0d {
	width: 1rem;
    height: 1rem;
}

.HIdCQAgqDJwvD0V9SNbS.np6noI7_VlUUvADzAThN {
	width: 4rem;
    height: 4rem;
}

.HIdCQAgqDJwvD0V9SNbS.PNWlQFf3gban5o3KlzMw {
	width: 8rem;
    height: 8rem;
}

@keyframes ubGSyLN9r1iyyU2ysL8D {
	to{
		transform:rotate(360deg)
	}
}
`, "",{"version":3,"sources":["webpack://./src/Spinner/style.module.css"],"names":[],"mappings":"AAAA,YAAY;;AAEZ;CACC,yBAAyB;CACzB,aAAa;IACV,uBAAuB;IACvB,mBAAmB;CACtB,WAAW;IACR,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;CACpB,+BAA+B;CAC/B,gCAAgC;CAChC,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,qBAAqB;CACrB,WAAW;CACX,cAAc;IACX,eAAe;CAClB,wCAAwC;CACxC,kBAAkB;CAClB,iBAAiB;CACjB;;;;EAIC;CACD,yBAAiB;SAAjB,iBAAiB;CACjB;2FAC0F;CAC1F,oDAAqD;AACtD;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,WAAW;IACR,YAAY;AAChB;;AAEA;CACC,WAAW;IACR,YAAY;AAChB;;AAEA;CACC,WAAW;IACR,YAAY;AAChB;;AAEA;CACC;EACC;CACD;AACD","sourcesContent":["/* Spinner */\r\n\r\n.spinner {\r\n\t--color-rgb: 94, 190, 214;\r\n\tdisplay: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n\twidth: 100%;\r\n    height: 100%;\r\n    max-width: 100px;\r\n    max-height: 100px;\r\n    aspect-ratio: 1/1;\r\n\tpadding-left: calc(-0.5rem / 2);\r\n\tpadding-right: calc(-0.5rem / 2);\r\n\toverflow: hidden;\r\n}\r\n\r\n.spinner::before {\r\n\tcontent: \"\";\r\n\tdisplay: inline-block;\r\n\twidth: 100%;\r\n\tmax-width: 90%;\r\n    max-height: 90%;\r\n\t--border-width: clamp(0.2em, 10%, 0.5em);\r\n\tborder-radius: 50%;\r\n\taspect-ratio: 1/1;\r\n\t--mask: radial-gradient(\r\n\t\tfarthest-side,\r\n\t\ttransparent calc(100% - var(--border-width) - 0.5px),\r\n\t\t#000 calc(100% - var(--border-width) + 0.5px)\r\n\t);\r\n\tmask: var(--mask);\r\n\tbackground: linear-gradient(to top, rgba(var(--color-rgb), 1), rgba(var(--color-rgb), 0.5)) 100% 0/50% 100% no-repeat,\r\n\t\t\tlinear-gradient(rgba(var(--color-rgb), 0.5) 50%, transparent 95%) 0 0/50% 100% no-repeat;\r\n\tanimation: button-spinner-border .85s linear infinite;\r\n}\r\n\r\n.spinner.contrast {\r\n\t--color-rgb: 255, 255, 255;\r\n}\r\n\r\n.spinner.orange {\r\n\t--color-rgb: 251, 163, 29;\r\n}\r\n\r\n.spinner.small {\r\n\twidth: 1rem;\r\n    height: 1rem;\r\n}\r\n\r\n.spinner.middle {\r\n\twidth: 4rem;\r\n    height: 4rem;\r\n}\r\n\r\n.spinner.large {\r\n\twidth: 8rem;\r\n    height: 8rem;\r\n}\r\n\r\n@keyframes button-spinner-border {\r\n\tto{\r\n\t\ttransform:rotate(360deg)\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinner": `HIdCQAgqDJwvD0V9SNbS`,
	"button-spinner-border": `ubGSyLN9r1iyyU2ysL8D`,
	"contrast": `ruv_DA3ta96laLErzD91`,
	"orange": `ugaDW5dB4BqWMOAundeZ`,
	"small": `T9zL9FLLrHf6kvbpGe0d`,
	"middle": `np6noI7_VlUUvADzAThN`,
	"large": `PNWlQFf3gban5o3KlzMw`
};
export default ___CSS_LOADER_EXPORT___;
